// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * These are all the dtypes known by Lizard / raster-service
 * @export
 */
export const DType = {
  I2: "i2",
  I4: "i4",
  F4: "f4",
  F8: "f8",
  U1: "u1",
  U2: "u2",
  U4: "u4",
} as const;
export type DType = (typeof DType)[keyof typeof DType];

export function instanceOfDType(value: any): boolean {
  for (const key in DType) {
    if (Object.prototype.hasOwnProperty.call(DType, key)) {
      if (DType[key as keyof typeof DType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function DTypeFromJSON(json: any): DType {
  return DTypeFromJSONTyped(json, false);
}

export function DTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DType {
  return json as DType;
}

export function DTypeToJSON(value?: DType | null): any {
  return value as any;
}

export function DTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): DType {
  return value as DType;
}
